import { Text } from "@radix-ui/themes";

export default function ZVisionText() {
  return (
    <>
      <div className="container py-3">
        <div className='row pb-3'>
          <div className='col'>
            <Text as="p" mb="5" size="6">
            Can we think differently? Can we live differently? 
            </Text>
          </div>
        </div>

        <div className='row pb-3'>
          <div className='col'>
            <Text as="p" mb="5" size="4">
              The world is an accumulation of common-places: whether artistic or scholarly, technocratic or bucolic, progressive or conservative. 
              They isolate human beings from a life in relations, turning their existences into cages of estrangement and hollowness. 
              Biodiversity is being extinguished, gods and spirits hide themselves, natural beings are reduced to things, and human sociality collapses under the imperative of quantification, mechanization, and interchangeability.
            </Text>
          </div>
        </div>

        <div className='row pb-3'>
          <div className='col'>
            <Text as="p" mb="5" size="4">
              In order to make room for something different, we need to work in the in-between-places, so that ‘the common’ may give way to ‘the singular’, but there is no line connecting those scattered spaces. 
              We must avoid what is already defined and taken for granted in them. 
              This involves cutting across different disciplines, bringing forward different projects at the center and margin of those disciplines with the willpower to restitute what is being destroyed.
            </Text>
          </div>
        </div>

        <div className='row pb-3'>
          <div className='col'>
            <Text as="p" mb="5" size="4">
              Working in the interstices is the art of transversality. 
              Transversality consists in disclosing the reverse-side of common-places and working creatively to expand it.
            </Text>
          </div>
        </div>

        <div className='row pb-3'>
          <div className='col'>
            <Text as="p" mb="5" size="4">
              Vision is not seeing something special, or hallucinating, or showing oneself off as ‘visionary’. 
              Vision consists in doing singular work at the interstices of 
              a ready-made and taken-for-granted world.
              We propose a cultural effort to open a gap and breathe into another space, individually and collectively, filling one’s lungs with an air of change. 
            </Text>
          </div>
        </div>

        <div className='row pb-3'>
          <div className='col'>
            <Text as="p" mb="5" size="4">
              Can we learn from others instead of wanting to instruct them? Can we bring poles together instead of keeping them apart? Can we compose instead of destroying? Can we nurture experience instead of reproducing abstractions? 
              Can we render ‘thinking’ and ‘living’ essentially interdependent?
              Can we fight poetically?
            </Text>
          </div>
        </div>

        <div className='row pb-3'>
          <div className='col'>
            <Text as="p" mb="5" size="4">
              This is our wager. A performative voice intending 
              to reach the tone of individual and collective transformation.
              A voice welling up neither from the surface of existing commonplaces nor from the depths of inexistent landscapes, but from the interstices of a world-configuration in process. 
            </Text>
          </div>
        </div>

      </div>
  
    </>
  )
}
